import React, { useState } from 'react'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import {
  DATE_RANGES,
  HEALTH_HISTORY_FILTERS,
  rangeLabel,
} from '../utils'
import {
  Controls,
  SearchInput,
  FilterButton,
  CustomRange,
  ActionButton,
} from '../styles'

const Dropdown = ({ label, value, children }) => {
  const [anchor, setAnchor] = useState(null)
  const close = () => setAnchor(null)

  return (
    <>
      <FilterButton
        type="button"
        aria-haspopup="true"
        onClick={event => setAnchor(event.currentTarget)}
      >
        {label}: <b>{value}</b>
        <ArrowDropDownIcon />
      </FilterButton>
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={close}
        MenuListProps={{ sx: { minWidth: 220 } }}
      >
        {children(close)}
      </Menu>
    </>
  )
}

const DateRangeOptions = ({ range, custom, today, onChange, close }) => {
  const [from, setFrom] = useState(custom.from || today)
  const [to, setTo] = useState(custom.to || today)

  return (
    <>
      {DATE_RANGES.map(option => (
        <MenuItem
          key={option.value}
          selected={range === option.value}
          onClick={() => {
            onChange(option.value)
            close()
          }}
        >
          {option.label}
        </MenuItem>
      ))}
      <CustomRange onKeyDown={event => event.stopPropagation()}>
        <b>Custom range</b>
        <label>
          From
          <input
            type="date"
            value={from}
            min={today}
            onChange={event => setFrom(event.target.value)}
          />
        </label>
        <label>
          To
          <input
            type="date"
            value={to}
            min={from}
            onChange={event => setTo(event.target.value)}
          />
        </label>
        <ActionButton
          type="button"
          disabled={!from || !to || to < from}
          style={{ justifyContent: 'center' }}
          onClick={() => {
            onChange('custom', { from, to })
            close()
          }}
        >
          Apply
        </ActionButton>
      </CustomRange>
    </>
  )
}

const Filters = ({
  search,
  onSearch,
  range,
  custom,
  today,
  onRange,
  typeId,
  types,
  onType,
  healthHistory,
  onHealthHistory,
}) => (
  <Controls>
    <SearchInput
      placeholder="Search patients..."
      aria-label="Search patients"
      value={search}
      onChange={event => onSearch(event.target.value)}
    />

    <Dropdown label="Dates" value={rangeLabel(range, custom)}>
      {close => (
        <DateRangeOptions
          range={range}
          custom={custom}
          today={today}
          onChange={onRange}
          close={close}
        />
      )}
    </Dropdown>

    <Dropdown
      label="Type"
      value={
        typeId === 'all'
          ? 'All types'
          : types.find(type => type.id === typeId)?.title || 'All types'
      }
    >
      {close =>
        [{ id: 'all', title: 'All types' }, ...types].map(type => (
          <MenuItem
            key={type.id}
            selected={typeId === type.id}
            onClick={() => {
              onType(type.id)
              close()
            }}
          >
            {type.title}
          </MenuItem>
        ))
      }
    </Dropdown>

    <Dropdown
      label="Health history"
      value={HEALTH_HISTORY_FILTERS.find(f => f.value === healthHistory).label}
    >
      {close =>
        HEALTH_HISTORY_FILTERS.map(filter => (
          <MenuItem
            key={filter.value}
            selected={healthHistory === filter.value}
            onClick={() => {
              onHealthHistory(filter.value)
              close()
            }}
          >
            {filter.label}
          </MenuItem>
        ))
      }
    </Dropdown>
  </Controls>
)

export default Filters
